export default __webpack_public_path__ + "static/media/porche-wrap-1.c0212f0a.jpeg";